module.exports = ReactDOM;


/*****************
 ** WEBPACK FOOTER
 ** external "ReactDOM"
 ** module id = 2
 ** module chunks = 0
 **/